import { render, staticRenderFns } from "./LegalEntityForm.vue?vue&type=template&id=6d57d2a8&"
import script from "./LegalEntityForm.vue?vue&type=script&lang=js&"
export * from "./LegalEntityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d57d2a8')) {
      api.createRecord('6d57d2a8', component.options)
    } else {
      api.reload('6d57d2a8', component.options)
    }
    module.hot.accept("./LegalEntityForm.vue?vue&type=template&id=6d57d2a8&", function () {
      api.rerender('6d57d2a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/tabs/LegalEntityForm.vue"
export default component.exports